// @ts-nocheck
import React from 'react'
import TetherPortal from 'components/common/TetherPortal'

export const ToolTip = ({
  children,
  order = 'top bottom left right',
  ...props
}) => (
  <TetherPortal order={order} className="ToolTip" {...props}>
    <div className="content">{children}</div>
  </TetherPortal>
)

export const useTooltip = (speed = 200, delay = speed) => {
  const [open, setOpen] = React.useState(false)
  const ref = React.useRef()
  const timeout = React.useRef()
  const onMouseEnter = React.useCallback(ev => {
    clearTimeout(timeout.current)
    if (!open) {
      timeout.current = setTimeout(() => {
        setOpen(true)
      }, delay)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const onMouseLeave = React.useCallback(ev => {
    clearTimeout(timeout.current)
    // 200 millisecond delay before hiding.
    timeout.current = setTimeout(() => {
      setOpen(false)
    }, 200)
  }, [])
  return [
    {
      ref,
      onMouseEnter,
      onMouseLeave,
    },
    { open, anchorRef: ref, speed: speed * 1 },
  ]
}

export const HelpText = ({ children, content, speed, delay, ...props }) => {
  const [parentProps, tooltipProps] = useTooltip(speed, delay)
  return (
    <span className="HelpText" {...parentProps}>
      <span className="children">{children}</span>
      <ToolTip {...props} {...tooltipProps}>
        {content}
      </ToolTip>
    </span>
  )
}
